import Breadcrumb, {
  BreadcrumbItemType,
  BreadcrumbSeparatorType,
} from 'antd/es/breadcrumb/Breadcrumb';
import React from 'react';

interface IProps {
  items: Partial<BreadcrumbItemType & BreadcrumbSeparatorType>[] | undefined;
}
const BreadcrumbComponent = ({ items }: IProps) => (
  <Breadcrumb className="text-lg m-2" items={items} />
);

export default BreadcrumbComponent;
